(() => {
  const initPhotoLightbox = () => {
    const main = document.querySelector('#MainContent');
    if (!main || document.querySelector('.press-lightbox')) return;

    const links = [...main.querySelectorAll('a[href*="griffey-approved-"]')].filter((link) =>
      link.querySelector('img')
    );

    if (!links.length) return;

    links.forEach((link, index) => {
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.classList.add('press-lightbox-trigger');
      link.setAttribute('aria-haspopup', 'dialog');
      link.dataset.photoLightboxIndex = String(index);
    });

    const dialog = document.createElement('dialog');
    dialog.className = 'press-lightbox';
    dialog.setAttribute('aria-label', 'Photo viewer');
    dialog.innerHTML = `
      <div class="press-lightbox__shell">
        <button class="press-lightbox__close" type="button" aria-label="Close photo viewer">×</button>
        <button class="press-lightbox__nav press-lightbox__nav--previous" type="button" aria-label="Previous photo">‹</button>
        <figure class="press-lightbox__figure">
          <img class="press-lightbox__image" alt="">
          <figcaption class="press-lightbox__caption" aria-live="polite"></figcaption>
        </figure>
        <button class="press-lightbox__nav press-lightbox__nav--next" type="button" aria-label="Next photo">›</button>
      </div>
    `;
    document.body.appendChild(dialog);

    const shell = dialog.querySelector('.press-lightbox__shell');
    const figure = dialog.querySelector('.press-lightbox__figure');
    const image = dialog.querySelector('.press-lightbox__image');
    const caption = dialog.querySelector('.press-lightbox__caption');
    const closeButton = dialog.querySelector('.press-lightbox__close');
    const previousButton = dialog.querySelector('.press-lightbox__nav--previous');
    const nextButton = dialog.querySelector('.press-lightbox__nav--next');

    let currentIndex = 0;
    let lastTrigger = null;

    const preloadAdjacent = () => {
      if (links.length < 2) return;
      const previous = new Image();
      previous.src = links[(currentIndex - 1 + links.length) % links.length].href;
      const next = new Image();
      next.src = links[(currentIndex + 1) % links.length].href;
    };

    const showPhoto = (index) => {
      currentIndex = (index + links.length) % links.length;
      const link = links[currentIndex];
      const thumbnail = link.querySelector('img');

      image.src = link.href;
      image.alt = thumbnail?.alt || `Griffey photo ${currentIndex + 1}`;
      caption.textContent = `${currentIndex + 1} / ${links.length}`;

      previousButton.hidden = links.length < 2;
      nextButton.hidden = links.length < 2;
      preloadAdjacent();
    };

    const openPhoto = (index, trigger) => {
      lastTrigger = trigger;
      showPhoto(index);
      dialog.showModal();
      document.documentElement.classList.add('press-lightbox-open');
      closeButton.focus({ preventScroll: true });
    };

    const closePhoto = () => {
      if (dialog.open) dialog.close();
    };

    links.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        openPhoto(index, link);
      });
    });

    closeButton.addEventListener('click', closePhoto);
    previousButton.addEventListener('click', () => showPhoto(currentIndex - 1));
    nextButton.addEventListener('click', () => showPhoto(currentIndex + 1));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target === shell || event.target === figure) closePhoto();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPhoto(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showPhoto(currentIndex + 1);
      }
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('press-lightbox-open');
      image.removeAttribute('src');
      lastTrigger?.focus({ preventScroll: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPhotoLightbox, { once: true });
  } else {
    initPhotoLightbox();
  }
})();
